// @flow

import { observer } from "mobx-react";
import * as React from "react";

import PasswordStrength from "app/components/PasswordStrength/PasswordStrength";
import PasswordConfirmation from "app/components/PasswordConfirmation/PasswordConfirmation";

type Props = {
    showLabels?: boolean
};

type State = {
    password: string
};

@observer
export default class PasswordForm extends React.Component<Props, State> {
    password: string;

    constructor(props: Props) {
        super(props);
        this.state = { password: "" };
    }

    handleChange = (password: string) => {
        this.setState({ password });
    };

    render() {
        return (
            <div>
                <div className="form-group">
                    {this.props.showLabels && (
                        <label htmlFor="password">New password</label>
                    )}
                    <PasswordStrength onChange={this.handleChange} />
                </div>

                <div className="form-group">
                    {this.props.showLabels && (
                        <label htmlFor="password_confirmation">
                            Confirm new password
                        </label>
                    )}
                    <PasswordConfirmation password={this.state.password} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/PasswordForm/PasswordForm.js